import React from 'react';

import { Modal, Tag, message } from 'antd';

import fetch from './../fetch';
import utils from './../../utils';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'employeeName', label: '职工姓名', width: 120 },
    { key: 'employeeCode', label: '职工工号', width: 120 },
    { key: 'totalSemester', label: '学期课时总数', width: 120 },
    { key: 'adjustSemester', label: '学期调串课次数', width: 120 },
    { key: 'basicScore', label: '基本分总分', width: 120 },
    { key: 'additionalTargetName', label: '附加项名称', width: 120 },
    { key: 'additionalScore', label: '附加项得分', width: 120 },
    { key: 'finalScore', label: '总分', width: 120 },
    { key: 'rank', label: '名次', width: 120 },
    { key: 'finalGrade', label: '评定等级', width: 120 },
    { key: 'termName', label: '学期', width: 120 }
]);

const columnsArray = [
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'employeeName', label: '职工姓名', width: 120 },
    { key: 'employeeCode', label: '职工工号', width: 120 },
    { key: 'totalSemester', label: '学期课时总数', width: 120 },
    { key: 'adjustSemester', label: '学期调串课次数', width: 120 },
    { key: 'basicScore', label: '基本分总分', width: 120 },
    { key: 'additionalTargetName', label: '附加项名称', width: 120 },
    { key: 'additionalScore', label: '附加项得分', width: 120 },
    { key: 'finalScore', label: '总分', width: 120 },
    { key: 'rank', label: '名次', width: 120 },
    { key: 'finalGrade', label: '评定等级', width: 120 },
    { key: 'termName', label: '学期', width: 120 }
]

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('teacherQualitySummary/query?' + params.join('&'), keywords)
        .then(response => {
            let extParams = response.payload.meta.extParams;
            let newArray = []
            if (extParams.targetNames && extParams.targetNames.length > 0) {
                for (let i = 0; i < columnsArray.length; i++) {
                    if (i === 7) {
                        extParams.targetNames.forEach((o, index) => {
                            newArray.push({
                                key: `targetName${index + 1}`,
                                label: o,
                                width: 100
                            })
                        })
                    }
                    newArray.push(columnsArray[i])
                }
            }
            return {
                data: response.payload.data,
                headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
            }
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const remove = (ids) => {
    return fetch.post(`teacherQualitySummary/remove`, ids)
}

const saveSetting = (domain) => {
    return fetch.post(`teacherQualitySummary/saveSetting`, domain)
}

const getSetting = () => {
    return fetch.post(`teacherQualitySummary/getSetting`)
}

export default {
    headers,
    querySearch,
    onSelect,
    setRefresh,
    getSelection,
    remove,
    saveSetting,
    getSetting
}